import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { connectSocket } from '../../lib/socket';
import NotificationToasts from './NotificationToasts';
import SiteFooter from '../../components/SiteFooter';
import TokenService from '../../lib/tokenService';
import { redirectToLogin } from '../../lib/authRedirect';
import './MainLayout.css';

const MainLayout = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]); // [{id, wa_id, contact_name, message}]
  const pathRef = useRef(location.pathname);
  const currentChatRef = useRef(null);

  useEffect(() => {
    if (!TokenService.getToken()) {
      redirectToLogin();
    }
  }, []);
  
  useEffect(() => { 
    pathRef.current = location.pathname;
    // Extract wa_id from path if on chat page: /main/chat/:waid
    const match = location.pathname.match(/\/main\/chat\/([^\/]+)/);
    currentChatRef.current = match ? match[1] : null;
  }, [location.pathname]);

  useEffect(() => {
    const socket = connectSocket();
    if (!socket) return;

    const onNewMessage = (newMsg) => {
      console.log('socket:new_message(layout)', newMsg);
      if (!newMsg || !newMsg.wa_id) return;
      
      const path = pathRef.current || '';
      const onChatPage = path.startsWith('/main/chat');
      const currentChat = currentChatRef.current;
      
      // Show notification if:
      // 1. Not on chat page, OR
      // 2. On chat page but message is from a different contact
      const shouldShow = !onChatPage || (onChatPage && currentChat !== newMsg.wa_id);
      
      if (shouldShow) {
        const preview = newMsg.message_content || newMsg.message_body || newMsg.body || newMsg.text || '';
        const contactName = newMsg.contact_name || newMsg.name || '';
        setNotifs((prev) => {
          const item = { 
            id: Date.now() + Math.random(), 
            wa_id: newMsg.wa_id, 
            contact_name: contactName,
            message: typeof preview === 'string' ? preview : '' 
          };
          const next = [item, ...prev];
          // keep stack reasonable (max 5 notifications)
          return next.slice(0, 5);
        });
      }
    };

    socket.on('new_message', onNewMessage);
    return () => {
      try { socket.off('new_message', onNewMessage); } catch {}
    };
  }, []);

  return (
    <div className="mainl">
      <Sidebar />
      <div className="main-layout-column">
        <Navbar />
        <div className="main-layout-content">
          <div className="main-layout-outlet">
            <Outlet />
          </div>
          <SiteFooter className="site-footer--app" />
        </div>
      </div>
      <NotificationToasts
        items={notifs}
        onClose={(id) => setNotifs((prev) => prev.filter((n) => n.id !== id))}
        onOpen={(id, waId) => {
          if (waId) navigate(`/main/chat/${waId}`);
          setNotifs((prev) => prev.filter((n) => n.id !== id));
        }}
      />
    </div>
  );
};

export default MainLayout;
